import { useQuery } from '@tanstack/react-query'

import { api } from '@/lib/api'
import {
  PROMPT_BODY_MAX_DEFAULT,
  PROMPT_BODY_MIN,
  type PromptConfigResponse,
} from '@sdr-agend/admin-schemas'

/**
 * `usePromptConfig` — exposes the live `prompt_max_chars` from
 * `system_settings` (plus the hard floor) so the prompt editor UI can gate
 * itself against the same cap the API enforces in `validateBody`.
 *
 * Falls back to the seed constants while the request is in flight or if it
 * fails (manager without read access, network hiccup, etc.). The server is
 * the source of truth on save either way.
 */
export function usePromptConfig(): { maxChars: number; minChars: number } {
  const { data } = useQuery<PromptConfigResponse>({
    queryKey: ['admin-prompts', 'config'],
    queryFn: async () => api<PromptConfigResponse>('/admin/prompts/config'),
    staleTime: 60_000,
    retry: false,
  })

  return {
    maxChars: data?.maxChars ?? PROMPT_BODY_MAX_DEFAULT,
    minChars: data?.minChars ?? PROMPT_BODY_MIN,
  }
}
